import { MutationTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";
import propertyPictureTypesStore from "./property-picture-types.store";
import {
    IPropertyPictureModel,
    //   PropertyArrayTypeModel
} from "../../../../models/property";
import { itemStateConstant } from "../../../../common";
import { DataHelper } from "../../../../utils/data-helper";
import {
    PROPERTY_TAB_EVOLUTION_PICTURES,
    PROPERTY_TAB_ENVIRONMENT_PICTURES
} from "../../../../common/property.constant";
import { deepClone } from "fast-json-patch";
import _ from "lodash";

const pictureMutations: MutationTree<IPropertyEditState> = <MutationTree<IPropertyEditState>>{
    [propertyPictureTypesStore.Set.LIST_OF_PROPERTY_PICTURES]: (state: IPropertyEditState, listOfPropertyPictures: IPropertyPictureModel[]) => {
        state.property.Pictures = listOfPropertyPictures;
    },

    /**
     * HANDLE INSERT
     */
    [propertyPictureTypesStore.Set.INSERT_PROPERTY_PICTURES]: (state: IPropertyEditState, payload) => {
        let list = state.property.Pictures;
        //@ts-ignore
        let origin = state.originalProperty.Pictures;
        let type = 'Pictures'
        if (payload.type == PROPERTY_TAB_EVOLUTION_PICTURES) {
            list = state.property.ProjectEvolutionPictures;
            origin = state.originalProperty.ProjectEvolutionPictures;
            type = 'ProjectEvolutionPictures'
        } else if (payload.type == PROPERTY_TAB_ENVIRONMENT_PICTURES) {
            list = state.property.ProjectEnvironmentPictures;
            origin = state.originalProperty.ProjectEnvironmentPictures;
            type = 'ProjectEnvironmentPictures'
        }

        if (!list) {
            state.property[type] = [];
            state.originalProperty[type] = [];
            list = state.property[type];
        }

        let minId = -1;
        if (list.length > 0) {
            // calculate for min id
            let addedItems = list.filter(
                x => x.ItemState === itemStateConstant.Added
            );
            if (addedItems.length > 0) {
                minId = Math.min.apply(
                    Math,
                    addedItems.map(function (o) {
                        return o.Id;
                    })
                );
            }
        }

        // add item to list
        payload.list.forEach((x, index) => {
            if (x.UploadFile) {
                const file = list.find(p => p.Id == x.UploadFile.Id);
                if (file) {
                    file.DescriptionOfCA = x.DescriptionOfCA;
                    file.DescriptionOfDE = x.DescriptionOfDE;
                    file.DescriptionOfEN = x.DescriptionOfEN;
                    file.DescriptionOfFR = x.DescriptionOfFR;
                    file.DescriptionOfNL = x.DescriptionOfNL;
                    file.DescriptionOfSP = x.DescriptionOfSP;
                    file.HeightOfImage = x.HeightOfImage;
                    file.OriginalUrl = x.OriginalUrl;
                    file.OriginalPublishUrl = x.OriginalPublishUrl;
                    file.PictureTypeIds = x.PictureTypeIds;
                    file.PictureRoomIds = x.PictureRoomIds;
                    file.PublishOnInternet = x.PublishOnInternet;
                    file.SmallUrl = x.SmallUrl;
                    file.SmallPublishUrl = x.SmallPublishUrl;
                    file.WidthOfImage = x.WidthOfImage;
                }
            } else {
                minId = minId - 1;
                x.Id = minId;
                x.ItemState = itemStateConstant.Added;

                const newFile: IPropertyPictureModel = {};
                newFile.Id = x.Id;
                newFile.PropertyId = state.property.Id;
                newFile.PublishOnInternet = x.PublishOnInternet;
                newFile.DescriptionOfCA = x.DescriptionOfCA;
                newFile.DescriptionOfDE = x.DescriptionOfDE;
                newFile.DescriptionOfEN = x.DescriptionOfEN;
                newFile.DescriptionOfFR = x.DescriptionOfFR;
                newFile.DescriptionOfNL = x.DescriptionOfNL;
                newFile.DescriptionOfSP = x.DescriptionOfSP;
                newFile.HeightOfImage = x.HeightOfImage;
                newFile.OriginalUrl = x.OriginalUrl;
                newFile.OriginalPublishUrl = x.OriginalPublishUrl;
                // newFile.PictureNumber = x.PropertyId ? x.PictureNumber : -1;
                newFile.PictureNumber = x.PictureNumber;
                newFile.PictureTypeIds = x.PictureTypeIds;
                newFile.PictureRoomIds = x.PictureRoomIds;
                newFile.PublishOnInternet = true;
                newFile.SmallUrl = x.SmallUrl;
                newFile.SmallPublishUrl = x.SmallPublishUrl;
                newFile.WidthOfImage = x.WidthOfImage;
                newFile.ItemState = x.ItemState;

                list.push(newFile);
            }
        });

        // We have to sort the list by ItemState, because we have to detect the correct index of the picture.
        // The PictureNumber is not unique, because we have to count the deleted pictures.
        const temp = _.orderBy(deepClone(list), ["PictureNumber", "ItemState"], ["asc", "asc"]);
        temp.forEach((pic, i) => {
            if (pic.ItemState != itemStateConstant.Added && pic.ItemState != itemStateConstant.Deleted) {
                pic.ItemState = itemStateConstant.Modified;
            }
            const tempIndex = pic.Id ? list.findIndex(x => x.Id === pic.Id) : list.findIndex(x => x.TempId === pic.TempId);
            // Update new order base on index.
            pic.PictureNumber = i;
            list[tempIndex] = deepClone(pic);
        });
    },

    /**
     * HANDLE UPDATE
     */
    [propertyPictureTypesStore.Set.UPDATE_PROPERTY_PICTURE]: (
        state: IPropertyEditState,
        payload: any
    ) => {
        let list = state.property.Pictures;

        if (payload.type == PROPERTY_TAB_EVOLUTION_PICTURES) {
            list = state.property.ProjectEvolutionPictures;
        } else if (payload.type == PROPERTY_TAB_ENVIRONMENT_PICTURES) {
            list = state.property.ProjectEnvironmentPictures;
        }

        var entity = list.find(c => c.Id == payload.data.Id);
        if (entity != undefined) {
            entity[payload.data.Field] = payload.data.Value;
            if (entity.ItemState != itemStateConstant.Added)
                entity.ItemState = itemStateConstant.Modified;

            // update PublishOnInternet for prev items
            // if (
            //     payload.data.Field === "PublishOnInternet" &&
            //     Boolean(payload.data.Value) === true
            // ) {
            //     const prevEntities = list.filter(
            //         c => c.PictureNumber < entity.PictureNumber
            //     );
            //     prevEntities.forEach(x => {
            //         x.PublishOnInternet = true;
            //         if (x.ItemState != itemStateConstant.Added)
            //             x.ItemState = itemStateConstant.Modified;
            //     });
            // }
        }
    },

    /** HANDLE UPDATE PROPERTY IS ARRAY */
    [propertyPictureTypesStore.Set.UPDATE_PROPERTY_ARRAY_PICTURE]: (
        state: IPropertyEditState,
        payload: any
    ) => {
        let list = state.property.Pictures;

        if (payload.type == PROPERTY_TAB_EVOLUTION_PICTURES) {
            list = state.property.ProjectEvolutionPictures;
        } else if (payload.type == PROPERTY_TAB_ENVIRONMENT_PICTURES) {
            list = state.property.ProjectEnvironmentPictures;
        }

        var entity = list.find(c => c.Id == payload.data.Id);
        if (entity != undefined) {
            // update state for this entity
            if (entity.ItemState != itemStateConstant.Added)
                entity.ItemState = itemStateConstant.Modified;

            let currentValues = [];
            currentValues = entity[payload.data.Field];

            // loop all values in old array
            // if it is not exit in new array value
            //    delete if it status is addnew
            currentValues.forEach((x, index) => {
                let exitItem = payload.data.Value.find(c => c == x.Id);
                if (exitItem == null) {
                    if (x.ItemState == itemStateConstant.Added) {
                        currentValues.splice(index, 1);
                    } else {
                        x.ItemState = itemStateConstant.Deleted;
                    }
                }
            });

            // loop all values in new array
            // if it is not exit in old array value
            //      add it to array and set itemstate =  addnew
            payload.data.Value.forEach(x => {

                let exitItem = currentValues.find(c => c.Id == x);
                if (exitItem == null) {
                    let newItem = {} as any;
                    newItem.Id = x;
                    newItem.ItemState = itemStateConstant.Added;
                    currentValues.push(newItem);
                } else {
                    if (exitItem.ItemState == itemStateConstant.Deleted) {
                        exitItem.ItemState = itemStateConstant.Unchanged;
                    }
                }
            });
        }
    },

    /** HANDLE UPDATE PROPERTY IS ARRAY */
    [propertyPictureTypesStore.Set.UPDATE_PROPERTY_ARRAY_PICTURE_ROOM]: (
        state: IPropertyEditState,
        payload: any
    ) => {
        let list = state.property.Pictures;

        if (payload.type == PROPERTY_TAB_EVOLUTION_PICTURES) {
            list = state.property.ProjectEvolutionPictures;
        } else if (payload.type == PROPERTY_TAB_ENVIRONMENT_PICTURES) {
            list = state.property.ProjectEnvironmentPictures;
        }

        var entity = list.find(c => c.Id == payload.data.Id);
        if (entity != undefined) {
            // update state for this entity
            if (entity.ItemState != itemStateConstant.Added)
                entity.ItemState = itemStateConstant.Modified;

            let currentValues = [];
            currentValues = entity[payload.data.Field];
            let oldValues = deepClone(currentValues);
            // loop all values in old array
            // if it is not exit in new array value
            //    delete if it status is addnew
            oldValues.forEach((x, index) => {
                if (!x.Id) {
                    const currentIndex = currentValues.findIndex(c => c.TempId === x.TempId)
                    currentValues.splice(currentIndex, 1);
                } else {
                    let exitItem = payload.data.Value.find(c => c.Id == x.Id);
                    if (exitItem == null) {
                        const currentIndex = currentValues.findIndex(c => c.Id === x.Id)
                        if (x.ItemState == itemStateConstant.Added) {
                            currentValues.splice(currentIndex, 1);
                        } else {
                            currentValues[currentIndex].ItemState = itemStateConstant.Deleted;
                        }
                    }
                }

            });

            // loop all values in new array
            // if it is not exit in old array value
            //      add it to array and set itemstate =  addnew
            payload.data.Value.forEach(x => {
                if (!x.Id) {
                    let newItem = {} as any;
                    newItem.Id = 0;
                    newItem.TempId = x.TempId;
                    newItem.ItemState = itemStateConstant.Added;
                    currentValues.push(newItem);
                } else {
                    let exitItem = currentValues.find(c => c.Id == x.Id);
                    if (exitItem == null) {
                        let newItem = {} as any;
                        newItem.Id = x.Id;
                        newItem.ItemState = itemStateConstant.Added;
                        currentValues.push(newItem);
                    } else {
                        if (exitItem.ItemState == itemStateConstant.Deleted) {
                            exitItem.ItemState = itemStateConstant.Unchanged;
                        }
                    }
                }
            });
        }
    },

    /** HANDLE DELETE */
    [propertyPictureTypesStore.Set.DELETE_PROPERTY_PICTURE]: (
        state: IPropertyEditState,
        payload: any
    ) => {
        let list = state.property.Pictures;
        if (payload.type == PROPERTY_TAB_EVOLUTION_PICTURES) {
            list = state.property.ProjectEvolutionPictures;
        } else if (payload.type == PROPERTY_TAB_ENVIRONMENT_PICTURES) {
            list = state.property.ProjectEnvironmentPictures;
        }
        let item = list.find(x => x.Id === payload.data);
        let index = list.indexOf(item);
        const newIndex = list.length - 1;

        // We have to sort the list by ItemState, because we have to detect the correct index of the picture.
        // The PictureNumber is not unique, because we have to count the deleted pictures.
        const temp = _.orderBy(deepClone(list), ["PictureNumber", "ItemState"], ["asc", "asc"]);
        const oldIndex = temp.findIndex(x => x.Id === payload.data);

        // sort, shift item
        DataHelper.insertAndShift(temp, oldIndex, newIndex);
        temp.forEach((pic, i) => {
            if (pic.ItemState != itemStateConstant.Added && pic.ItemState != itemStateConstant.Deleted) {
                pic.ItemState = itemStateConstant.Modified;
            }
            const tempIndex = pic.Id ? list.findIndex(x => x.Id === pic.Id) : list.findIndex(x => x.TempId === pic.TempId);
            // Update new order base on index.
            pic.PictureNumber = i;
            list[tempIndex] = deepClone(pic);
        });

        let newItem = list.find(x => x.Id === payload.data);
        if (newItem.ItemState === itemStateConstant.Added) {
            list.splice(index, 1);
        } else {
            newItem.ItemState = itemStateConstant.Deleted;
            // Remove from list to render data table
            list.splice(index, 1);

            // Add again and update itemstate for BE handle delete
            list.splice(index, 0, newItem);
        }
    },

    /** HANDLE DELETE */
    [propertyPictureTypesStore.Set.REODER_PROPERTY_PICTURE]: (
        state: IPropertyEditState,
        payload: any
    ) => {
        let list = state.property.Pictures;

        if (payload.type == PROPERTY_TAB_EVOLUTION_PICTURES) {
            list = state.property.ProjectEvolutionPictures;
        } else if (payload.type == PROPERTY_TAB_ENVIRONMENT_PICTURES) {
            list = state.property.ProjectEnvironmentPictures;
        }

        // get list item do not include deleted items
        let items = list.filter(
            x => x.ItemState != itemStateConstant.Deleted
        );

        // detect min picture number
        let minPictureNumber = Math.min.apply(
            Math,
            items.map(function (o) {
                return o.PictureNumber;
            })
        );

        if (minPictureNumber > 0) minPictureNumber = -1;

        const prevEntities = list.filter(
            c =>
                c.ItemState != itemStateConstant.Deleted &&
                c.PictureNumber > minPictureNumber
        ).sort((a, b) => {
            return a.PictureNumber - b.PictureNumber;
        });

        prevEntities.forEach(x => {
            minPictureNumber = minPictureNumber + 1;

            // MUST GET ITEM FROM STORE TO UPDATED
            let item = list.find(c => c.Id == x.Id);
            if (item != null) {
                item.PictureNumber = minPictureNumber;
                // IMPORTANT: UPDATE STATE FOR ITEM
                if (item.ItemState != itemStateConstant.Added)
                    item.ItemState = itemStateConstant.Modified;
            }
        });
    },
    [propertyPictureTypesStore.Set.RESORT_PROPERTY_PICTURE]: (
        state: IPropertyEditState,
        payload: any
    ) => {
        let list = state.property.Pictures;

        if (payload.type == PROPERTY_TAB_EVOLUTION_PICTURES) {
            list = state.property.ProjectEvolutionPictures;
        } else if (payload.type == PROPERTY_TAB_ENVIRONMENT_PICTURES) {
            list = state.property.ProjectEnvironmentPictures;
        }

        if (list.length > 0) {
            list.forEach((p, i) => {
                p.PictureNumber = i;
            });
        }
    },

    [propertyPictureTypesStore.Set.MOVE_PROPERTY_PICTURE]: (
        state: IPropertyEditState,
        payload: any
    ) => {
        let list = state.property.Pictures;

        if (payload.type == PROPERTY_TAB_EVOLUTION_PICTURES) {
            list = state.property.ProjectEvolutionPictures;
        } else if (payload.type == PROPERTY_TAB_ENVIRONMENT_PICTURES) {
            list = state.property.ProjectEnvironmentPictures;
        }

        // Solve the wrong picture number cases
        const existNewPictureIndex = payload.list.findIndex(x => x.PictureNumber === payload.newPictureNr);

        const newIndex = existNewPictureIndex >= 0 ? existNewPictureIndex : payload.newPictureNr;
        const oldIndex = payload.list.findIndex(x => x.PictureNumber === payload.oldPictureNr);
        // sort, shift item
        DataHelper.insertAndShift(payload.list, oldIndex, newIndex);
        payload.list.forEach((pic, i) => {
            if (pic.ItemState != itemStateConstant.Added) {
                pic.ItemState = itemStateConstant.Modified;
            }
            const index = pic.Id ? list.findIndex(x => x.Id === pic.Id) : list.findIndex(x => x.TempId === pic.TempId);
            // Update new order base on index.
            pic.PictureNumber = i;
            list[index] = deepClone(pic);
        });
    },
    [propertyPictureTypesStore.Set.REPLACE_PROPERTY_PICTURE]: (
        state: IPropertyEditState,
        payload: any
    ) => {

        let list = state.property.Pictures;
    
        if (payload.type === PROPERTY_TAB_EVOLUTION_PICTURES) {
            list = state.property.ProjectEvolutionPictures;
        } else if (payload.type === PROPERTY_TAB_ENVIRONMENT_PICTURES) {
            list = state.property.ProjectEnvironmentPictures;
        }
    
    
        const oldPicture = list.find(pic => pic.PictureNumber === payload.oldPictureNr && pic.ItemState !== itemStateConstant.Deleted);
        const newPicture = list.find(pic => pic.PictureNumber === payload.newPictureNr && pic.ItemState !== itemStateConstant.Deleted);
        if (!oldPicture || !newPicture) return;

        // Swap PictureNumber between old and new pictures
        const tempPictureNumber = oldPicture.PictureNumber;
        oldPicture.PictureNumber = newPicture.PictureNumber;
        newPicture.PictureNumber = tempPictureNumber;
    
        // Mark both pictures as Modified unless they are newly added or already deleted
        if (oldPicture.ItemState !== itemStateConstant.Added && oldPicture.ItemState !== itemStateConstant.Deleted) {
            oldPicture.ItemState = itemStateConstant.Modified;
        }
    
        if (newPicture.ItemState !== itemStateConstant.Added && newPicture.ItemState !== itemStateConstant.Deleted) {
            newPicture.ItemState = itemStateConstant.Modified;
        }
    
        // Soft delete the old picture (same logic as DELETE_PROPERTY_PICTURE)
        const deleteIndex = list.indexOf(oldPicture);
    
        if (oldPicture.ItemState === itemStateConstant.Added) {
            // If it's a newly added picture, simply remove it from the list
            list.splice(deleteIndex, 1);
        } else {
            // Mark the picture as Deleted for backend handling
            oldPicture.ItemState = itemStateConstant.Deleted;
    
            // Temporarily remove it from the list to avoid rendering
            list.splice(deleteIndex, 1);
    
            // Re-insert it to ensure backend knows about the deletion
            list.splice(deleteIndex, 0, oldPicture);
        }
    
        // Re-sort the list based on updated PictureNumber
        list.sort((a, b) => a.PictureNumber - b.PictureNumber);
    },       
    [propertyPictureTypesStore.Set.REMOVE_PROPERTY_PICTURE]: (
        state: IPropertyEditState,
        payload: any
    ) => {
        let list = state.property.Pictures;

        if (payload.type == PROPERTY_TAB_EVOLUTION_PICTURES) {
            list = state.property.ProjectEvolutionPictures;
        } else if (payload.type == PROPERTY_TAB_ENVIRONMENT_PICTURES) {
            list = state.property.ProjectEnvironmentPictures;
        }

        let item = list.find(x => x.Id === payload.data);

        if (item) {
            let index = list.indexOf(item);
            list.splice(index, 1);
        }
    },
    [propertyPictureTypesStore.Set.REMOVE_MOVE_ALL_UN_UPLOAD_PROPERTY_PICTURE]: (
        state: IPropertyEditState,
        payload: any
    ) => {
        let list = state.property.Pictures;

        if (payload.type == PROPERTY_TAB_EVOLUTION_PICTURES) {
            list = state.property.ProjectEvolutionPictures;
        } else if (payload.type == PROPERTY_TAB_ENVIRONMENT_PICTURES) {
            list = state.property.ProjectEnvironmentPictures;
        }

        const unUploadPictures = list.filter(r => {
            return !r.OriginalUrl;
        });

        unUploadPictures.forEach(f => {
            list.splice(list.indexOf(f), 1);
        });
    }
};

export default pictureMutations;
